export const GET_ACCESS_SESSION_QUERY_KEY = 'getAccessSession';

export const GET_ACCESS_SESSION_DETAILS_QUERY_KEY = 'getAccessSessionDetails';

export const LIST_ACCESS_SESSIONS_QUERY_KEY = 'listAccessSessions';

export const LIST_ACCESS_SESSION_GROUPS_QUERY_KEY = 'listAccessSessionGroups';

export const GET_ACCESS_SESSION_REQUEST_TEMPLATE_QUERY_KEY = 'getAccessSessionRequestTemplate';
